import { Delete, Get, Post, Put } from '../..';
import { ServiceRegionType } from '../../../type';
import { AppURL, getRegionalURL } from '../../../utility/AppURL';

export const getWebhookList = async (region: ServiceRegionType, token: string) => {
    const headers = {
        'as-token': token,
    };
    const response = await Get(getRegionalURL(AppURL.slack, region), null, headers).then((res) => res.json());
    return response;
};

export const getWebhook = async (region: ServiceRegionType, token: string, id: string) => {
    const headers = {
        'as-token': token,
    };
    const response = await Get(getRegionalURL(AppURL.slack, region) + '/' + id, null, headers).then((res) => res.json());
    return response;
};

export const updateWebhook = async (region: ServiceRegionType, token: string, id: string, webhook: any) => {
    const headers = {
        'as-token': token,
        'Content-Type': 'application/json',
    };
    const url = getRegionalURL(AppURL.slack, region) + '/' + id;
    const response = await Put(url, webhook, headers).then((res) => res.json());
    return response;
};

export const createWebhook = async (region: ServiceRegionType, token: string, webhook: any) => {
    const headers = {
        'as-token': token,
        'Content-Type': 'application/json',
    };

    const response = await Post(getRegionalURL(AppURL.slack, region), webhook, headers).then((res) => res.json());
    return response;
};

export const deleteWebhook = async (region: ServiceRegionType, token: string, id: string) => {
    const headers = {
        'as-token': token,
    };
    const url = getRegionalURL(AppURL.slack, region) + '/' + id;
    const response = await Delete(url, null, headers).then((res) => res.json());
    return response;
};